//LoaderBG.vue



/* eslint-disable no-undef */
<template>

	<div class="bouncer">
		<div class="element">
			<p>S</p>
			<!-- <svg class="svg" width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M20.482 11.172C20.482 11.172 20.5275 28.5197 20.558 32.3L25 32.3C30.662 32.3 31.616 31.35 32.338 27.512C32.794 25.194 32.224 22.838 30.97 21.774L29.982 20.938L30.742 20.178C31.768 19.152 32.072 17.86 31.844 15.542C31.616 13.224 30.476 11.894 28.272 11.4C26.79 11.02 20.482 11.172 20.482 11.172ZM27.436 14.706C27.854 15.086 28.12 15.846 28.12 16.796C28.279 19.3581 26.368 19.7658 24.206 19.57C24.206 17.7961 24.282 14.25 24.282 14.25C24.282 14.25 26.79 14.136 27.436 14.706ZM27.854 23.598C28.5887 24.2537 29.2296 26.6097 28.5 28C27.689 29.1853 25.439 29.1602 24.206 29.07C24.1814 27.2271 24.282 22.838 24.282 22.838C24.282 22.838 27.018 22.61 27.854 23.598Z" fill="black"/>
			</svg> -->
		</div>
		<div class="element">
			<p>W</p>
			<!-- <svg class="svg" width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M37.1956 36.86H28.2232V38.38C28.2232 38.38 35.7703 38.38 37.1956 38.38V47.5C37.5097 47.5 38.6389 47.5 38.6389 47.5C38.6389 47.5 38.6147 41.0924 38.6389 38.38C40.1556 38.38 47.88 38.38 47.88 38.38V36.86H38.6389V27.74H37.1956V36.86Z" fill="black"/>
			</svg> -->
		</div>
		<div class="element">
			<p> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;A</p>
			<!-- <svg class="svg" width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M46.55 43.396C43.282 44.574 42.408 47.196 42.636 54.91C42.75 59.47 42.902 60.496 43.624 62.016C44.65 64.068 46.208 64.98 48.792 64.98C50.16 64.98 50.898 64.95 52 64L53.2 62.624V64.5999C53.2 64.5999 55.1293 64.6 55.86 64.6V58.9V53.2H52.63H49.4V56.24C49.4 56.24 50.9485 56.24 52.06 56.24V58.14C52.06 61.37 49.666 63.004 47.728 61.066C46.626 59.964 46.17 55.936 46.55 51.034C46.778 48.298 47.006 47.576 47.728 46.854C49.438 45.144 51.756 46.132 52.288 48.792L52.5 50.16H55.86L55.784 48.222C55.556 46.056 54.606 44.536 52.972 43.738C51.566 43.016 48.032 42.826 46.55 43.396Z" fill="black"/>
			</svg> -->
		</div>
	</div>

	<!-- <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M20.482 11.172C20.482 11.172 20.5275 28.5197 20.558 32.3L25 32.3C30.662 32.3 31.616 31.35 32.338 27.512C32.794 25.194 32.224 22.838 30.97 21.774L29.982 20.938L30.742 20.178C31.768 19.152 32.072 17.86 31.844 15.542C31.616 13.224 30.476 11.894 28.272 11.4C26.79 11.02 20.482 11.172 20.482 11.172ZM27.436 14.706C27.854 15.086 28.12 15.846 28.12 16.796C28.279 19.3581 26.368 19.7658 24.206 19.57C24.206 17.7961 24.282 14.25 24.282 14.25C24.282 14.25 26.79 14.136 27.436 14.706ZM27.854 23.598C28.5887 24.2537 29.2296 26.6097 28.5 28C27.689 29.1853 25.439 29.1602 24.206 29.07C24.1814 27.2271 24.282 22.838 24.282 22.838C24.282 22.838 27.018 22.61 27.854 23.598Z" fill="black"/>
		<path d="M37.1956 36.86H28.2232V38.38C28.2232 38.38 35.7703 38.38 37.1956 38.38V47.5C37.5097 47.5 38.6389 47.5 38.6389 47.5C38.6389 47.5 38.6147 41.0924 38.6389 38.38C40.1556 38.38 47.88 38.38 47.88 38.38V36.86H38.6389V27.74H37.1956V36.86Z" fill="black"/>
		<path d="M46.55 43.396C43.282 44.574 42.408 47.196 42.636 54.91C42.75 59.47 42.902 60.496 43.624 62.016C44.65 64.068 46.208 64.98 48.792 64.98C50.16 64.98 50.898 64.95 52 64L53.2 62.624V64.5999C53.2 64.5999 55.1293 64.6 55.86 64.6V58.9V53.2H52.63H49.4V56.24C49.4 56.24 50.9485 56.24 52.06 56.24V58.14C52.06 61.37 49.666 63.004 47.728 61.066C46.626 59.964 46.17 55.936 46.55 51.034C46.778 48.298 47.006 47.576 47.728 46.854C49.438 45.144 51.756 46.132 52.288 48.792L52.5 50.16H55.86L55.784 48.222C55.556 46.056 54.606 44.536 52.972 43.738C51.566 43.016 48.032 42.826 46.55 43.396Z" fill="black"/>
	</svg> -->

</template>

<script>


export default {
	components: {
		
  },
  data() {
	return {
		
	};
  },
  methods: {  
	init() {
	},
  },
  mounted() {
	}
};
</script>



<style scoped>

.bouncer {
	display: flex; 
	/* justify-content: space-around; */
	/* align-items: flex-end; */
	/* border: 1px solid black; */
}

.element {
	/* background: #0077ff; */
	/* border: 1px solid black; */
	width: 20px;
	height: 20px;
	/* border-radius: 50%; */
	animation: bouncer 0.5s cubic-bezier(.19, .57, .3, .98 ) infinite alternate;
	margin-left:-10px;
	font-family: 'Roboto', sans-serif;
	font-weight: bold;
}

.svg {
	width: 50px;
	height: 50px;
}

.bouncer div:nth-child(2){ 
	animation-delay: 0.1s;
	/* opacity: .8; */
}

.bouncer div:nth-child(3){ 
	animation-delay: 0.2s;
	/* opacity: .6; */
}

@keyframes bouncer {
	from { transform: translateY(0) }
	to { transform: translateY(-100px) }
}

</style>